import STRATX_EXT_1 from "./STRATX_EXT_1";

export default {
  STRATX_EXT_1,
};
